import React from 'react';
import { Link } from 'react-router-dom';

import './Button.css';
import "../../styles/font-awesome-4.7.0/css/font-awesome.min.css";

const button = (props) =>
  !props.link ? (
    <button
      // className={["mn-ui-btn mn-ui-btn--next mr-a"].join(" ")}
      className={[
        "mn-ui-btn",
        `mn-ui-btn--${props.design}`,
        `${props.wide && `mn-ui-btn--${props.design}--${props.wide}`}`,
        `${props.mode && "disabled"}`,
      ].join(" ")}
      onClick={props.onClick}
      disabled={props.disabled || props.loading}
      type={props.type}
    >
      {props.loading ? "Loading..." : props.children}
    </button>
  ) : (
    <Link
      className={[
        "button",
        `button--${props.design}`,
        `button--${props.mode}`,
      ].join(" ")}
      to={props.link}
    >
      {props.children}
    </Link>
  );

export default button;
